import React, { useState, createContext } from "react";
import jsDig from "utils/jsDig.js";
import AccountSettingsModal from "./AccountSettingsModal";

export const SettingsContext = createContext();

export default function AccountSettingsButton(props) {
  let cog = require("images/lite/icons/settings.png");
  cog = <img className="settings-cog" alt="Settings" src={`/datapulse${cog}`} />;

  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!isModalOpen);

  //Users
  const [clientUsers, setClientUsers] = useState(props.users ? props.users.clients : []);
  const [teamUsers, setTeamUsers] = useState(props.users ? props.users.employees : []);

  //Basic Tab
  const [companyName, setCompanyName] = useState(props.company_name);
  const [baseCurrency, setBaseCurrency] = useState(jsDig(["client_account", "base_currency"], props));
  const [displayCurrency, setDisplayCurrency] = useState(jsDig(["client_account", "display_currency"], props));
  const [defaultObjective, setDefaultObjective] = useState(jsDig(["client_account", "dashboard_objective"], props));
  const [overviewDatasource, setOverviewDatasource] = useState(jsDig(["client_account", "overview_datasource"], props));
  const [website, setWebsite] = useState(jsDig(["client_account", "website"], props));
  const [clientLogo, setClientLogo] = useState(props.client_logo);

  //Account Ids
  const [facebookObjective, setFacebookObjective] = useState(jsDig(["social_section", "conversion_objective"], props));
  const [tiktokObjective, setTiktokObjective] = useState(jsDig(["social_section", "tiktok_conversion_objective"], props));
  const [semrushTargetLocation, setSemrushTargetLocation] = useState(jsDig(["seo_section", "semrush_target_location"], props));
  const [shopifyRevenueType, setShopifyRevenueType] = useState(jsDig(["ppc_section", "shopify_revenue_type"], props));
  const [shopifyCountryFilter, setShopifyCountryFilter] = useState(jsDig(["ppc_section", "shopify_country_filter"], props));
  const [googleAdsId, setGoogleAdsId] = useState(jsDig(["client_account", "platform_ids", "google_ads"], props));
  const [microsoftId, setMicrosoftId] = useState(jsDig(["client_account", "platform_ids", "microsoft_ads"], props));
  const [metaId, setMetaId] = useState(jsDig(["client_account", "platform_ids", "meta_ads"], props));
  const [tiktokId, setTiktokId] = useState(jsDig(["client_account", "platform_ids", "tiktok_ads"], props));
  const [googleAnalyticsId, setGoogleAnalyticsId] = useState(jsDig(["client_account", "platform_ids", "google_analytics"], props));
  const [semrushId, setSemrushId] = useState(jsDig(["client_account", "platform_ids", "semrush"], props));
  const [shopifyUrl, setShopifyUrl] = useState(jsDig(["client_account", "shopify_url"], props));
  const [amazonAdsId, setAmazonAdsId] = useState(jsDig(["client_account", "platform_ids", "amazon_ads"], props));
  const [amazonSellerCountry, setAmazonSellerCountry] = useState("US");
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(jsDig(["client_account", "platform_ids", "google_sheets_url"], props));
  const [mailchimpServerPrefix, setMailchimpServerPrefix] = useState(jsDig(["client_account", "platform_ids", "mailchimp_server_prefix"], props));

  //scripts
  const [excludeNbInShoppingKeywords, setExcludeNbInShoppingKeywords] = useState(jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "keyword"], props) || {});
  const [textConvertingQueryMiningScript, setTextConvertingQueryMiningScript] = useState(jsDig(["client_account", "scripts", "text_converting_query_mining_script"], props));
  const [emBmNegativeOverlapScript, setEmBmNegativeOverlapScript] = useState(jsDig(["client_account", "scripts", "em_bm_negative_overlap_script"], props));
  const [negativeDsaSyncScript, setNegativeDsaSyncScript] = useState(jsDig(["client_account", "scripts", "negative_dsa_sync_script"], props));
  const [excludeNbInShopping, setExcludeNbInShopping] = useState(jsDig(["client_account", "scripts", "exclude_nb_in_shopping", "enabled"], props));
  const [keywordCannibalizationScript, setKeywordCannibalizationScript] = useState(jsDig(["client_account", "scripts", "keyword_cannibalization_script"], props));
  const [youtubeChannelExcluder, setYoutubeChannelExcluder] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "enabled"], props));
  const [youtubeChannelExcluderCountries, setYoutubeChannelExcluderCountries] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "allowed_countries"], props));
  const [youtubeChannelExcluderTimeRange, setYoutubeChannelExcluderTimeRange] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_time_range"], props));
  const [youtubeChannelExcluderImpressionsThreshold, setYoutubeChannelExcluderImpressionsThreshold] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "impressions_threshold"], props));
  const [youtubeChannelExcluderGoogleSheet, setYoutubeChannelExcluderGoogleSheet] = useState(jsDig(["client_account", "scripts", "youtube_channel_excluder", "google_sheet"], props));

  //inflation
  const [inflation, setInflation] = useState(props.search_section.daily_yields);


  const contextValue = {
    isModalOpen,
    toggleModal,
    excludeNbInShoppingKeywords,
    setExcludeNbInShoppingKeywords,
    clientUsers,
    setClientUsers,
    teamUsers,
    setTeamUsers,
    companyName,
    setCompanyName,
    website,
    setWebsite,
    defaultObjective,
    setDefaultObjective,
    overviewDatasource,
    setOverviewDatasource,
    baseCurrency,
    setBaseCurrency,
    displayCurrency,
    setDisplayCurrency,
    clientLogo,
    setClientLogo,
    googleAnalyticsId,
    setGoogleAnalyticsId,
    googleAdsId,
    setGoogleAdsId,
    metaId,
    setMetaId,
    facebookObjective,
    setFacebookObjective,
    microsoftId,
    setMicrosoftId,
    tiktokId,
    setTiktokId,
    tiktokObjective,
    setTiktokObjective,
    semrushId,
    setSemrushId,
    semrushTargetLocation,
    setSemrushTargetLocation,
    shopifyRevenueType,
    setShopifyRevenueType,
    shopifyCountryFilter,
    setShopifyCountryFilter,
    shopifyUrl,
    setShopifyUrl,
    amazonAdsId,
    setAmazonAdsId,
    amazonSellerCountry,
    setAmazonSellerCountry,
    googleSheetsUrl,
    setGoogleSheetsUrl,
    mailchimpServerPrefix,
    setMailchimpServerPrefix,
    textConvertingQueryMiningScript,
    setTextConvertingQueryMiningScript,
    emBmNegativeOverlapScript,
    setEmBmNegativeOverlapScript,
    negativeDsaSyncScript,
    setNegativeDsaSyncScript,
    excludeNbInShopping,
    setExcludeNbInShopping,
    keywordCannibalizationScript,
    setKeywordCannibalizationScript,
    youtubeChannelExcluder,
    setYoutubeChannelExcluder,
    youtubeChannelExcluderCountries,
    setYoutubeChannelExcluderCountries,
    youtubeChannelExcluderTimeRange,
    setYoutubeChannelExcluderTimeRange,
    youtubeChannelExcluderImpressionsThreshold,
    setYoutubeChannelExcluderImpressionsThreshold,
    youtubeChannelExcluderGoogleSheet,
    setYoutubeChannelExcluderGoogleSheet,
    inflation,
    setInflation,
    ...props,
  };

  return (
    <SettingsContext.Provider value={contextValue}>
      <button id="account-settings-button" className="account-settings get-account-settings" onClick={toggleModal}>
        {cog}
        <p>Account Settings</p>
      </button>
      <AccountSettingsModal />
    </SettingsContext.Provider>
  );
}
